import { useQuery } from '@tanstack/react-query';

import type {
  ReturnedClientsAnalyticsParams,
  ReturnedClientsAnalyticsResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const RETURNED_CLIENTS_ANALYTICS_QUERY_KEY =
  'returned_clients_analytics';

export const useReturnedClientsAnalyticsQuery = (
  params: ReturnedClientsAnalyticsParams,
) =>
  useQuery({
    queryKey: [
      RETURNED_CLIENTS_ANALYTICS_QUERY_KEY,
      params.url,
      params.queryParams,
    ],
    queryFn: () =>
      HttpClient.request<ReturnedClientsAnalyticsResponseData>({
        method: 'GET',
        url: params.url,
        params: params.queryParams,
      }),
    enabled: false, // Manual trigger - user must click Filter button
    refetchOnWindowFocus: false,
    retry: false,
  });
